module.exports = "/_next/static/images/CompanyOverview-1a6e0f729bc67a7c65e92360f9f05640.jpg.webp";